import React, { useState, useEffect, useRef, useCallback } from "react";
import { Card, Spinner } from "react-bootstrap";
import { SYSTEM_DEFAULTS, ERROR_MESSAGES } from '../util/constants'
import { useSharedData } from "../context/sharedDataContext";
import HelperFunction from "../util/helper";

export default function Activity({preview = false}) {
    const [activities, setActivities] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const loaderRef = useRef(null);

    const { data: user, loading } = useSharedData();

    if(loading) {
        return <div className="d-flex justify-content-center my-5">
                    <Spinner animation="border" />
                </div>
    }

    // const fetchActivities = useCallback(async () => {
    //     const user = localStorage.getItem(SYSTEM_DEFAULTS.USER_CACHE);
    //     if (!user) return;
    
    //     setLoading(true);
    //     try {
    //       const res = await fetch(
    //         `${process.env.REACT_APP_WENGMACK_V1_BE_URL}/user/${user.id}/activities?page=${page}&limit=${SYSTEM_DEFAULTS.PAGE_SIZE}`
    //       );
    //       if (!res.ok) throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
    
    //       const data = await res.json();
    //       setActivities((prev) => [...prev, ...data.items]);
    //       setHasMore(data.items.length > 0);
    //     } catch (err) {
    //       console.error(err);
    //     } finally {
    //       setLoading(false);
    //     }
    // }, [page]);

    // useEffect(() => {
    //     fetchActivities();
    // }, [fetchActivities]);

    // Intersection Observer for infinite scroll
    // useEffect(() => {
    //     if (preview) return; // disable infinite scroll in preview mode

    //     const observer = new IntersectionObserver(
    //     (entries) => {
    //         if (entries[0].isIntersecting && hasMore && !loading) {
    //         setPage((prev) => prev + 1);
    //         }
    //     },
    //     { threshold: 1 }
    //     );

    //     if (loaderRef.current) observer.observe(loaderRef.current);
    //     return () => observer.disconnect();
    // }, [hasMore, loading, preview]);

    return (
        <Card className="recent-activity-card">
            <Card.Body>
                <div className="card-header-custom">
                {preview ? <h5><i className="bi bi-activity"></i> Recent Activity</h5> : <h5><i className="bi bi-activity"></i> Activity</h5> }
                <button className="activity-menu">⋯</button>
                </div>
                {user.activities.map((activity) => (
                    <div key={activity.id} className="activity-item">
                        <div className="activity-avatar"><i className="bi bi-check-circle"></i></div>
                        <div className="activity-content">
                            <div className="activity-text">
                                <strong>{activity.status}</strong> {activity.action}
                            </div>
                            <div className="activity-time">{HelperFunction.formatDateTime(activity.created_at)}</div>
                        </div>
                    </div>
                ))}

                {/* <div className="activity-list">
                    <div className="activity-day">
                        <h6>Today</h6>
                        {activities.slice(0, 3).map((activity, index) => (
                        <div key={index} className="activity-item">
                            <div className="activity-avatar"><i class="bi bi-check-circle"></i></div>
                            <div className="activity-content">
                            <div className="activity-text">
                                <strong>{activity.user}</strong> {activity.action}
                            </div>
                            <div className="activity-time">{activity.time}</div>
                            </div>
                        </div>
                        ))}
                    </div>
                    <div className="activity-day">
                        <h6>Yesterday</h6>
                        {activities.slice(3).map((activity, index) => (
                        <div key={index} className="activity-item">
                            <div className="activity-avatar"><i class="bi bi-check-circle"></i></div>
                            <div className="activity-content">
                            <div className="activity-text">
                                <strong>{activity.user}</strong> {activity.action}
                            </div>
                            <div className="activity-time">{activity.time}</div>
                            </div>
                        </div>
                        ))}
                    </div>
                </div> */}
                {!preview && <div ref={loaderRef} style={{ height: "40px" }} />}
                {loading && <><Spinner animation="border" /> <p>Loading...</p></>}
            </Card.Body>
        </Card>
    )
}